// extracted by mini-css-extract-plugin
module.exports = {"base":"SignIn_base__2un12","content":"SignIn_content__3vvab","ssoButton":"SignIn_ssoButton__1DpJs"};